<template>
  <div>
    <h2 class="fsize30-20px">Learning Package Includes:</h2>
    <ul class="list-disc lg:pt-10 md:pt-10 pt-2 pl-5 lg:mb-12 md:mb-12 mb-4">
      <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
        Pre-assessment tools
      </li>
      <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
        Self-assessment tools
      </li>
      <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
        Knowledge resources from the training program
      </li>
    </ul>
    <h2 class="fsize24-14">
      5 modules in total with each module being 4.5 hours long:
    </h2>
    <ul class="list-disc lg:pt-10 md:pt-10 pt-2 pl-5">
      <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
        An experiential curriculum focusing on perspectives, tools and means of
        engagement looking from the lens of a Caregiver
      </li>
      <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
        Peer learning and experience-based exercises, case studies, discussions,
        group work and role play
      </li>

      <li class="subtitle lh32px sm-lh25px sm-fsize14 mb-2">
        Reflection and self-work
      </li>
    </ul>
    <h2 class="fsize24-14">
      Curriculum Fee: INR {{ coachannounce[0].curriculumFee || "static" }} +
      Taxes
    </h2>
    <h2 class="fsize24-14">
      {{ coachannounce[0].title || "static" }}
    </h2>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  async mounted() {
    this.$store.dispatch("coach/getcoachannonce");
  },
  computed: {
    ...mapState("coach", {
      coachannounce: "coachannounce",
    }),
  },
};
</script>
